import { getIssues } from '@/api/issue';

export const searchIssues = (params: IIssue.IRequest.IGetIssues = {}): Promise<IIssue.IResponse.IData> => {
  return new Promise((resolve, reject) => {
    getIssues(params).then((res) => {
      resolve(res);
    }).catch((err) => {
      reject(err.message);
    });
  });
};
